<template>
    <div class="row mb-4">
        <div class="col-md-3 mb-4">
            <label class="form-label" for="product_group">Product Group</label>
            <select class="form-select" id="product_group" v-model="filters.product_group">
                <option value="">All</option>
                <option
                    v-for="productGroup in productGroups"
                    v-text="productGroup"
                ></option>
            </select>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="input-group">
                <input type="text" class="form-control" v-model="searchTerm" placeholder="Search product code...">
                <span class="input-group-text bg-body border-0">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm" :filters="filters">
        <template #headings>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="description">Description</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="code">Code</sortableTh>
            <th>Product Group</th>
            <th>WooCommerce Product</th>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="product in data" :key="product.id">
                <td>{{ product.description }}</td>
                <td>{{ product.code }}</td>
                <td>{{ product.product_group }}</td>
                <td>
                    <i v-if="product.has_woocommerce_product" class="fa fa-check text-success"></i>
                    <i v-else class="fa fa-times text-danger"></i>
                </td>
                <td v-html="product.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { reactive, ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
    productGroups: Array,
});

const orderBy = ref('code');
const orderAsc = ref(true);
const limit = ref(25);
const searchTerm = ref(null);
const filters = reactive({
    product_group: '',
});

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};
</script>
